var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_133_213)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#FF9777"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_133_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0147 8.33824V19.6618C15.0147 19.7983 14.9605 19.9292 14.864 20.0257C14.7674 20.1222 14.6365 20.1765 14.5 20.1765C14.3635 20.1765 14.2326 20.1222 14.1361 20.0257C14.0395 19.9292 13.9853 19.7983 13.9853 19.6618V8.33824C13.9853 8.20173 14.0395 8.07081 14.1361 7.97429C14.2326 7.87776 14.3635 7.82353 14.5 7.82353C14.6365 7.82353 14.7674 7.87776 14.864 7.97429C14.9605 8.07081 15.0147 8.20173 15.0147 8.33824ZM12.4412 13.4853H8.53585L9.71967 12.3079C9.80175 12.2079 9.84369 12.0809 9.83735 11.9517C9.831 11.8225 9.77682 11.7003 9.68534 11.6088C9.59386 11.5173 9.47162 11.4631 9.3424 11.4568C9.21318 11.4504 9.08622 11.4924 8.98622 11.5745L6.92739 13.6333C6.83074 13.7309 6.77652 13.8627 6.77652 14C6.77652 14.1374 6.83074 14.2691 6.92739 14.3667L8.98622 16.4256C9.0846 16.5207 9.21609 16.5739 9.35294 16.5739C9.4898 16.5739 9.62129 16.5207 9.71967 16.4256C9.81632 16.328 9.87055 16.1962 9.87055 16.0588C9.87055 15.9215 9.81632 15.7897 9.71967 15.6921L8.53585 14.5147H12.4412C12.5777 14.5147 12.7086 14.4605 12.8051 14.364C12.9017 14.2674 12.9559 14.1365 12.9559 14C12.9559 13.8635 12.9017 13.7326 12.8051 13.6361C12.7086 13.5395 12.5777 13.4853 12.4412 13.4853ZM22.0726 13.6333L20.0138 11.5745C19.9138 11.4924 19.7868 11.4504 19.6576 11.4568C19.5284 11.4631 19.4062 11.5173 19.3147 11.6088C19.2232 11.7003 19.169 11.8225 19.1627 11.9517C19.1563 12.0809 19.1983 12.2079 19.2803 12.3079L20.4642 13.4853H16.5588C16.4223 13.4853 16.2914 13.5395 16.1949 13.6361C16.0983 13.7326 16.0441 13.8635 16.0441 14C16.0441 14.1365 16.0983 14.2674 16.1949 14.364C16.2914 14.4605 16.4223 14.5147 16.5588 14.5147H20.4642L19.2803 15.6921C19.1837 15.7897 19.1295 15.9215 19.1295 16.0588C19.1295 16.1962 19.1837 16.328 19.2803 16.4256C19.3787 16.5207 19.5102 16.5739 19.6471 16.5739C19.7839 16.5739 19.9154 16.5207 20.0138 16.4256L22.0726 14.3667C22.1693 14.2691 22.2235 14.1374 22.2235 14C22.2235 13.8627 22.1693 13.7309 22.0726 13.6333Z",
    fill: "#F58866"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_133_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4706,
    height: 16.4706,
    fill: "white",
    transform: "translate(6.26471 5.76471)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftright);
export default __webpack_public_path__ + "static/media/leftright.9fc87a51b1a2b6106f211948eee8c4da.svg";
export { ForwardRef as ReactComponent };